import React, {Fragment} from 'react'
import Header from '../components/Header'
import { graphql, StaticQuery, Link } from 'gatsby'
import Footer from '../components/Footer'

class AppGuide extends React.Component{
    constructor(props){
        super(props)
    }

    render(){
        console.log('ss', this.props)
        const { mobileAlbert, appleLogo, googleLogo } = this.props.query;
        return(
            <Fragment>
                <Header logoColor="#46e2b9" classStatic="transparent" dropDownColor="black" title="Albert"/>
                <section class="logged-inner">
                    <div class="custom-container">
                        <div class="col-md-5 col-sm-5 col-lg-5 col-xs-12">
                            <div class="loged-img"><img src={mobileAlbert.publicURL} alt=""/></div>
                        </div>
                        <div class="col-md-7 col-sm-7 col-lg-7 col-xs-12">
                            <figcaption>
                                <h3>Så här kommer du igång med ditt <br/> barns kunskapsresa</h3>
                                <p>OBS: Gäller endast för ÅK 4 - ÅK 9</p>
                                <ol>
                                    <li>Efter att du skapat ditt kostnadsfria prova-på abonnemang här på hejalbert.se måste ni ladda ner appen för åk 4 - åk 9 i Appstore och Google Play. </li>
                                    <li>Ladda ner appen via ikonerna nedan.</li>
                                    <li>Använd de användaruppgifter ni fått på både mail och sms.</li>
                                    <li>Påbörja resan till att utveckla en mattemästare i familjen! </li>
                                </ol>
                                <div class="app-store">
                                    <img src={appleLogo.publicURL}/>
                                    <img src={googleLogo.publicURL}/>
                                </div>
                                <div class="baner-login-btn">
                                    <Link to="/register" class="appguide-btn">INGET KONTO? KLICKA HÄR!</Link>
                                </div>
                            </figcaption>
                        </div>
                    </div>
                </section>
                <Footer/>
            </Fragment>
        )
    }
}

export default (props) => (
    <StaticQuery
        query= { graphql`
                query {
                    mobileAlbert: file(relativePath: {regex: "/albert-phone-bg-banner/"}) {
                        publicURL
                    }
                    appleLogo: file(relativePath: {regex: "/app-store/"}){
                        publicURL
                    }
                    googleLogo: file(relativePath: {regex: "/google-play/"}){
                        publicURL
                    }
                }`
            }
        render={(data)  => (
           <AppGuide query={data} {...props}/>
        )}
    />
)